// Centralized fetch wrapper that attaches JWT and handles 401 globally.
export default async function apiFetch(path, options = {}) {
  const token = localStorage.getItem("jwt_token");
  const opts = { ...options };
  const headers = Object.assign({}, opts.headers || {});

  // Attach Authorization header when token present
  if (token) headers.Authorization = `Bearer ${token}`;

  // If there's a body and Content-Type is not set, default to JSON (skip for FormData)
  if (opts.body && !(opts.body instanceof FormData)) {
    // If caller passed a plain object, stringify it for JSON requests
    if (typeof opts.body !== "string") {
      try {
        opts.body = JSON.stringify(opts.body);
      } catch (e) {
        // fallback: leave as-is (might be a stream or other type)
      }
    }
    if (!headers["Content-Type"]) headers["Content-Type"] = "application/json";
  }

  opts.headers = headers;

  const res = await fetch(path, opts);

  if (res.status === 401) {
    // Clear local auth and redirect to login. Broadcast to other tabs.
    try {
      localStorage.removeItem("jwt_token");
      localStorage.removeItem("loggedInUser");
      localStorage.removeItem("lastActive");
      // small storage ping to notify other tabs
      localStorage.setItem("__logout__", Date.now());
      localStorage.removeItem("__logout__");
    } catch (e) {
      // ignore
    }
    // Force a reload/redirect to login page
    try {
      window.location.href = "/api/auth/login";
    } catch (e) {}
    const err = new Error("Unauthorized");
    err.status = 401;
    throw err;
  }

  if (!res.ok) {
    // Try to parse structured error
    const body = await res.json().catch(() => null);
    const message =
      (body && (body.error || body.message)) || `HTTP ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  // Return parsed JSON when possible, otherwise null
  return res.json().catch(() => null);
}